import { RigidBodyType } from "~/types/RigidBodyType";

export const getDefaultType = (): RigidBodyType => {
  return "dynamic";
};
